import request from '@/plugins/axios'

// 查询流程分页
export function auditProcessNodePage(data) {
    return request({
        url: '/sys/auditProcessNode/v1.0.0/page',
        method: 'post',
        data: data
    })
}

// 查询流程列表
export function auditProcessNodeList(data) {
    return request({
        url: '/sys/auditProcessNode/v1.0.0/list',
        method: 'post',
        data: data
    })
}

// 查询流程详细
export function auditProcessNodeDetail(id) {
    const data = {
        id : id
    };
    return request({
        url: '/sys/auditProcessNode/v1.0.0/detail',
        method: 'post',
        data
    })
}

export function auditProcessNodeAdd(data) {
    return request({
        url: '/sys/auditProcessNode/v1.0.0/add',
        method: 'post',
        data
    })
}

export function auditProcessNodeUpdate(data) {
    return request({
        url: '/sys/auditProcessNode/v1.0.0/update',
        method: 'post',
        data
    })
}

export function auditProcessNodeDelete(id) {
    const data = {
        id : id
    };
    return request({
        url: '/sys/auditProcessNode/v1.0.0/delete',
        method: 'post',
        data
    })
}
